import { render, staticRenderFns } from "./DeliveryComponent.vue?vue&type=template&id=ba798dfa"
import script from "./DeliveryComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryComponent.vue?vue&type=script&lang=js"
import style0 from "./DeliveryComponent.vue?vue&type=style&index=0&id=ba798dfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports